import { Dispatch } from "redux";
import Global from "../../passapp-sdk/global";
import User from "../../passapp-sdk/user";
import { store } from "../store";
import { AlertSeverity, showAlert } from "./types/alertTypes";
import {
  addPendingRequests,
  deletePendingRequest,
  pendingRequestFailure,
  startLoading,
  stopLoading,
} from "./types/pendingRequestTypes";

const global = new Global();
const user = new User();

export const updatePendingRequest =
  (id: string, action: string) => (dispatch: Dispatch) => {
    const auth = store.getState().auth;
    global
      .updatePendingRequest(auth.token, id, action)
      .then((response: any) => {
        if (response.status === "ok") {
          dispatch(deletePendingRequest(id));
          if (action === "accept") {
            dispatch(showAlert("Solicitud aprobada!", AlertSeverity.success));
          } else {
            dispatch(showAlert("Solicitud Rechazada!", AlertSeverity.success));
          }
        }
      })
      .catch((err) => {
        console.error(`Error: ${err}`);
        dispatch(pendingRequestFailure(err));
      });
  };

export const getAllPendingRequest =
  (token: string, convertDataTable: (pendingRequest: any[]) => any[]) =>
  (dispatch: Dispatch) => {
    if (token) {
      dispatch(startLoading());
      user
        .getPendingRequestsData(token)
        .then((response: any) => {
          dispatch(addPendingRequests(convertDataTable(response.data)));
        })
        .catch((err) => {
          console.info(err);
        })
        .finally(() => {
          dispatch(stopLoading());
        });
    }
  };
